import React from 'react'
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import { AcceptSource } from 'src/graphql.generated'
import { usePanelPatientUid } from '../../dashboard/panelContext'
import { formatDayTime, toIso } from '../../format'
import { advancedColors } from '../../theme'
import { usePatientRecord } from './usePatientRecord'

const CONSENT_SOURCE_TEXT: Record<AcceptSource, string> = {
  [AcceptSource.Verbal]: 'Consented verbally on',
  [AcceptSource.App]: 'Consented via app on',
  [AcceptSource.Web]: 'Consented via web on',
}

// Read-only, mirroring `TermsSection.tsx` — nothing here is writable.
const ConsentDocumentsPanel = () => {
  const uid = usePanelPatientUid()
  const { patient } = usePatientRecord(uid)
  const documents = patient?.privateUserData?.consentDocuments ?? []

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {documents.map((doc) => (
        <FormControlLabel
          key={doc.id}
          control={<Checkbox checked={Boolean(doc.acceptedAt)} disabled />}
          label={
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant="body2">{doc.title}</Typography>
              {doc.acceptedAt && (
                <Typography variant="caption" sx={{ color: advancedColors.inkMuted }}>
                  {doc.acceptSource ? CONSENT_SOURCE_TEXT[doc.acceptSource] : 'Consented on'}{' '}
                  {formatDayTime(toIso(doc.acceptedAt))}
                </Typography>
              )}
            </Box>
          }
        />
      ))}
    </Box>
  )
}

export default ConsentDocumentsPanel
